import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import type { ReactNode } from "react";

interface EmptyTableRowProps {
  colSpan: number;
  /** Left-align for a sentence or two; short messages stay centered. */
  align?: "left" | "center";
  children: ReactNode;
}

/** A full-width row with a centered message, for a table with nothing to show. */
export default function EmptyTableRow({ colSpan, align = "center", children }: EmptyTableRowProps) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align={align} sx={{ color: "text.secondary", py: 3 }}>
        {children}
      </TableCell>
    </TableRow>
  );
}
